import { Bad } from '@core/model/framework/Result/BadResult';
import { OkVal } from '@core/model/framework/Result/OkResult';
import { Usecase } from '@core/model/framework/usecase';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';
import type { WaitOnCaseStateNotificationGateway } from '@core/model/gateway/waitOnCaseStateNotificationGateway';
import { ValidCaseState } from '@core/model/domain/caseState';

export type WaitOnCaseStateNotificationInput = {
  userId: string;
  userToken: string;
};

export type WaitOnCaseStateNotificationOutput = Promise<
  OkVal<ValidCaseState> | Bad<'CASE_STILL_IN_PROGRESS' | 'STOP_POLLING_VIA_USER_ACTION'>
>;

@injectable()
export class WaitOnCaseStateNotification
  implements Usecase<WaitOnCaseStateNotificationInput, WaitOnCaseStateNotificationOutput>
{
  constructor(
    @inject(SERVICE_ID.waitOnCaseStateNotificationGateway)
    private readonly waitOnCaseStateNotificationGateway: WaitOnCaseStateNotificationGateway
  ) {}

  execute(input: WaitOnCaseStateNotificationInput): WaitOnCaseStateNotificationOutput {
    return this.waitOnCaseStateNotificationGateway.awaitCaseStateUpdate(input);
  }

  stop(): void {
    return this.waitOnCaseStateNotificationGateway.stopWaitingCaseStateUpdate();
  }
}
